import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Importez le routeur

import 'bootstrap/dist/css/bootstrap.min.css';

createApp(App).use(router).mount('#app'); // Utilisez le routeur
